export default __webpack_public_path__ + "static/media/shareableIllustrator.3f1db628.svg";